import React from "react";
import {KeywordEntity} from "../Entity/KeywordEntity.ts";
import {KeywordComponent} from "./KeywordComponent.tsx";
import {Box} from "@mui/material";

interface KeywordSetComponentProps {
	readonly keywords: KeywordEntity[];
}

export function KeywordSetComponent(props: KeywordSetComponentProps): React.ReactElement {
	function renderKeyword(entity: KeywordEntity): React.ReactElement {
		return <KeywordComponent key={entity.name.toString()} keyword={entity} />;
	}

	return <Box sx={{
		display: "flex",
		flexWrap: "wrap",
		gap: 1,
		justifyContent: "center"
	}}>
		{props.keywords.map(renderKeyword)}
	</Box>;
}